import { useEffect, useState } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseurladdress } from '../baseurl';
import { saveTokenInLocalStorage, saveUserID, saveUsername, saveRoleid } from '../authservice/authservice';
import "milligram";
import './login.css';
function Login() {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [Errors, setErrors] = useState("");
    const [erroremail, seterroremail] = useState("");
    const [errorpassword, seterrorpassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();
    useEffect(() => {
        if ('caches' in window) {
            caches.keys().then(function (names) {
                names.forEach(function (name) {
                    caches.delete(name);
                });
            });
        }
    }, [])

    const LoginButton = async (e) => {
        e.preventDefault();

        setErrors("");
        seterroremail("");
        seterrorpassword("");

        // Validation
        if (!username && !password) {
            setErrors("Please fill the required fields");
            return;
        }

        if (!username) {
            seterroremail("Please fill Username");
            return;
        }

        if (!password) {
            seterrorpassword("Please fill Password");
            return;
        }

        try {
            const res = await axios.post(baseurladdress + "auth/login", {
                user_name: username,
                user_pass: password
            });

            console.log("Login response:", res.data);

            if (res.data.status === "success") {

                localStorage.setItem("selectedMenu", 2);


                saveTokenInLocalStorage(res.data.token);
                if (res.data.refreshToken || res.data.refresh_token) {
                    localStorage.setItem("refreshToken", res.data.refreshToken || res.data.refresh_token);
                }
                saveUserID(res.data.user_id);
                saveUsername(res.data.user_name);
                saveRoleid(res.data.roleid);



                console.log("Saved username:", localStorage.getItem("username"));

                navigate("/dashboard");

            } else if (res.data.status === "notfound") {
                setErrors("Login failed. Check username/password");
            } else {
                setErrors("Login failed. Please try again.");
            }

        } catch (err) {
            console.error("Login error:", err);
            if (err.response) {

                setErrors(err.response.data.message || "Login failed. Please try again.");
            } else if (err.request) {

                setErrors("Server not responding. Please try again later.");
            } else {

                setErrors("An error occurred. Please try again.");
            }
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-box">

                <div className="auth-header">
                    <h1>DDC LIVE TRACKING</h1>
                </div>

                <form className="auth-form" onSubmit={LoginButton}>

                    {Errors && <div className="auth-error">{Errors}</div>}

                    {/* Username */}
                    <div className="form-group">
                        <label>Username</label>
                        <div className="input-group">
                            <span className="input-icon">
                                <i className="fa fa-user" />
                            </span>
                            <input
                                type="text"
                                placeholder="Enter your username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>
                        {erroremail && <span className="field-error">{erroremail}</span>}
                    </div>

                    {/* Password */}
                    <div className="form-group">
                        <label>Password</label>
                        <div className="input-group">
                            <span className="input-icon">
                                <i className="fa fa-lock" />
                            </span>
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <span
                                className="toggle-password"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                            </span>
                        </div>
                        {errorpassword && <span className="field-error">{errorpassword}</span>}
                    </div>

                    <button type="submit" className="auth-btn">
                        LOGIN
                    </button>

                </form>

                <div className="auth-footer">
                    © 2026 DDC Live Tracking
                </div>

            </div>
        </div>
    );


}

export default Login;